import React from 'react';
import { Box } from '@material-ui/core';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import FinancialCredibility from './FinancialCredibility';
import Liquidity from './Liquidity';
import IncomeStability from './IncomeStability';
import RentStability from './RentStability';
import FinancialMarkers from './FinancialMarkers';
import Events from './Events';
import EventsFeed from './EventsFeed';
import { ContainerBox } from './ReportBoxes.style-elements';

const ReportBoxes: React.FC = () => {
  return (
    <ContainerBox>
      <FsGridContainer>
        <FsGridItem xs={12} lg={6} isFlex>
          <FinancialCredibility />
        </FsGridItem>
        <FsGridItem xs={12} lg={6} isFlex>
          <Liquidity />
        </FsGridItem>
        <FsGridItem xs={12} lg={6} isFlex>
          <IncomeStability />
        </FsGridItem>
        <FsGridItem xs={12} lg={6} isFlex>
          <RentStability />
        </FsGridItem>
        <FsGridItem xs={12} lg={4} isFlex>
          <FinancialMarkers />
        </FsGridItem>
        <FsGridItem xs={12} lg={8} isFlex>
          <Box display="flex" width="100%" flexWrap="wrap">
            <Events />
            <EventsFeed />
          </Box>
        </FsGridItem>
      </FsGridContainer>
    </ContainerBox>
  );
};

export default ReportBoxes;
